import { StyleSheet } from 'react-native';
export function useStyle({ customStyle }) {
    const { containerHeight = 72, actionTextStyle = {} } = customStyle;
    return {
        styles: StyleSheet.create({
            slideContainer: {
                width: '100%',
                // height: containerHeight,
                // minHeight: 180,
                position: 'relative',
                overflow: 'hidden',
            },
            actionContainer: Object.assign(Object.assign({ width: '100%', 
                // height: containerHeight,
                flexGrow: 1, overflow: 'hidden' }, StyleSheet.absoluteFillObject), { flexDirection: 'row', justifyContent: 'space-between' }),
            actions: {
                flexDirection: 'row',
                // backgroundColor: 'purple',
                height: '100%',
            },
            action: {
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
            },
            actionTxt: Object.assign({ fontSize: 14, color: '#FFF', fontFamily: 'PingFang SC', fontWeight: 'normal' }, actionTextStyle),
            item: {
                width: '100%',
                flexGrow: 1,
                // height: containerHeight,
                flex: 1,
            },
            right: {
                height: '100%',
                flexDirection: 'row',
            },
        }),
    };
}
